import { render, staticRenderFns } from "./VisitaMedico.vue?vue&type=template&id=ea2a2c30&"
import script from "./VisitaMedico.vue?vue&type=script&lang=js&"
export * from "./VisitaMedico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports